import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { PadronAguaGenerales, CatTipoDocumentos, GeneraFiscalizacionesInput, GeneraFiscalizaciones, DatosCartoweb, AuxJasper, ParametroJasper, CancelaFiscalizacionesInput, CancelaFiscalizaciones, AplicaFiscalizacionesInput, AplicaFiscalizaciones } from 'app/entidades/entidades';
import { CatTipoDocumentosService } from "../../servicios/cat-tipo-documentos.service";
import { GeneraFiscalizacionesService } from "../../servicios/genera-fiscalizaciones.service";
import { CancelaFiscalizacionesService } from "../../servicios/cancela-fiscalizaciones.service";
import { AplicaFiscalizacionesService } from "../../servicios/aplica-fiscalizaciones.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { PadronAguaGeneralesComponent } from 'app/componentes/padron-agua-generales/padron-agua-generales.component';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthenticationService } from 'app/servicios';

@Component({
  selector: "app-ejecucion-fiscal",
  templateUrl: "./ejecucion-fiscal.component.html",
  styleUrls: ["./ejecucion-fiscal.component.css"],
})
export class EjecucionFiscalComponent implements OnInit {
  public id$: number;
  public idAgua: number;
  public cuentaAgua: number;
  public idTipoDocumento: Number;
  public selecteddoc2: any;

  public usuario: any;
  message: string;
  errorMessage: any;
  padronAguaGenerales: PadronAguaGenerales[] = [];
  padronAguaGenerale: PadronAguaGenerales = new PadronAguaGenerales();
  selecteddoc: any;
  @ViewChild(PadronAguaGeneralesComponent, { static: false })
  childPadronAguaGenerales;
  catTipoDocumentos: CatTipoDocumentos[];
  catTipoDocumentosFrom: FormGroup;
  generaFiscalizaciones: GeneraFiscalizaciones;
  cancelaFiscalizaciones: CancelaFiscalizaciones;
  aplicaFiscalizaciones: AplicaFiscalizaciones;
  public auxJasper: AuxJasper;
  display: boolean = false;
  showDialog() {
    this.display = true;
  }
  @Input("generaFiscalizacionesInput")
  generaFiscalizacionesInput: GeneraFiscalizacionesInput;
  @Input("cancelaFiscalizacionesInput")
  cancelaFiscalizacionesInput: CancelaFiscalizacionesInput;
  @Input("aplicaFiscalizacionesInput")
  aplicaFiscalizacionesInput: AplicaFiscalizacionesInput;
  constructor(
    private catTipoDocumentosService: CatTipoDocumentosService,
    private generaFiscalizacionesService: GeneraFiscalizacionesService,
    private cancelaFiscalizacionesService: CancelaFiscalizacionesService,
    private aplicaFiscalizacionesService: AplicaFiscalizacionesService,
    private router: Router,
    muestraMensaje: MuestraMensaje,
    private authenticationService: AuthenticationService
  ) {
    this.message = "Padron Aguas Generales";
  }

  muestraMensaje: MuestraMensaje = new MuestraMensaje();

  async ngOnInit() {
    this.getAllCatTipoDucumentos();
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;
  }
  async getAllCatTipoDucumentos() {
    try {
      const datoRetorno = await this.catTipoDocumentosService
        .getAll()
        .toPromise();
      this.catTipoDocumentos = datoRetorno;

      console.log("Retorna Cat Tipos Documentos BD", datoRetorno);
    } catch (e) {
      if (e.responde) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso Por getAllCatTipoDucumentos", this.catTipoDocumentos);
    }
  }
  generar() {
    console.log(this.generaFiscalizacionesInput);
    try {
      this.generaFiscalizacionesInput = new GeneraFiscalizacionesInput();
      console.log(
        "childPadronAguaGenerales",
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados
      );
      if (
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados == null
      ) {
        throw new Error("Seleccionar una cuenta.");
      } else {
        for (
          var i = 0;
          i <
          this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados.length;
          i++
        ) {
          try {
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == 1
            ) {
              this.cuentaAgua = null;
              this.cuentaAgua = this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                i
              ].cuentaAgua;
              throw new Error(
                "La cuenta: " +
                  this.cuentaAgua +
                  " tiene un proceso fiscal En Vigente."
              );
            }
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == 3
            ) {
              this.cuentaAgua = null;
              this.cuentaAgua = this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                i
              ].cuentaAgua;
              throw new Error(
                "La cuenta: " +
                  this.cuentaAgua +
                  " tiene un proceso fiscal En Proceso."
              );
            }
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == null
            ) {
              console.log("hoa");

              console.log(this.generaFiscalizacionesInput);
              this.generaFiscalizacionesInput.idAgua.push(
                this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                  i
                ].idAgua
              );
              console.log(this.generaFiscalizacionesInput.idAgua);
              console.log(
                "--------------------------------------------------------"
              );
              this.generaFiscalizacionesInput.idTipoDucumento = this.selecteddoc2.id;
              this.generaFiscalizacionesInput.idUsuario = this.usuario.id;
            }
          } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
          }
        }
        console.log("Par INPUT GeneraFisc", this.generaFiscalizacionesInput);

        this.getGeneraFiscalizaciones(this.generaFiscalizacionesInput);
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados = null;
        console.log(
          "Limpia child",
          this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados
        );
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por Generar");
    }
  }
  async getGeneraFiscalizaciones(
    generaFiscalizacionesInput: GeneraFiscalizacionesInput
  ) {
    try {
      const datoRetorno = await this.generaFiscalizacionesService
        .getBusquedas(generaFiscalizacionesInput)
        .toPromise();
      this.generaFiscalizaciones = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.muestraMensaje.notification(
        "Proceso Concluido (Generar).",
        "top",
        "center"
      );
      console.log("Paso por  getGeneraFiscalizaciones");
    }
  }
  async imprimir() {
    try {
      this.generaFiscalizacionesInput = new GeneraFiscalizacionesInput();

      for (
        var i = 0;
        i <
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados.length;
        i++
      ) {
        this.idAgua = this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
          i
        ].idAgua;
        this.idTipoDocumento = this.selecteddoc.id;

        this.auxJasper = new AuxJasper();
        console.log(this.idTipoDocumento);
        if (this.idTipoDocumento == 1) {
          this.auxJasper.JasperReport.nombreReporte = "CartaInvitacion";
        }
        if (this.idTipoDocumento == 2) {
          this.auxJasper.JasperReport.nombreReporte = "Citatorio";
        }
        if (this.idTipoDocumento == 3) {
          this.auxJasper.JasperReport.nombreReporte = "CreditoFiscal";
        }
        if (this.idTipoDocumento == 4) {
          this.auxJasper.JasperReport.nombreReporte = "FormatoDeInspeccion";
        }
        if (this.idTipoDocumento == 5) {
          this.auxJasper.JasperReport.nombreReporte =
            "NotificacionDeRestriccion";
        }
        this.auxJasper.JasperReport.tipo = "pdf";
        let _id_agua = new ParametroJasper();
        let _id_tipo_documento = new ParametroJasper();
        _id_agua.nombre = "_id_agua";
        _id_tipo_documento.nombre = "_id_tipo_documento";
        _id_agua.valor = this.idAgua + "";
        _id_tipo_documento.valor = this.idTipoDocumento + "";
        console.log(
          "Parametros Jasper",
          _id_agua.nombre,
          " = ",
          _id_agua.valor
        );
        console.log(
          "Parametros Jasper",
          _id_tipo_documento.nombre,
          " = ",
          _id_tipo_documento.valor
        );
        console.log(this.auxJasper);
        await this.auxJasper.ParametroJasper.push(_id_agua);
        await this.auxJasper.ParametroJasper.push(_id_tipo_documento);

        this.showDialog();

        //this.router.navigateByUrl("componentes/visor", { state: this.auxJasper });//Para mostrarlo con pagina independiente
      }
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }
  cancelar() {
    try {
      this.cancelaFiscalizacionesInput = new CancelaFiscalizacionesInput();
      if (
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados == null
      ) {
        throw new Error("Seleccionar una cuenta.");
      } else {
        for (
          var i = 0;
          i <
          this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados.length;
          i++
        ) {
          try {
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == null
            ) {
              this.cuentaAgua = null;
              this.cuentaAgua = this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                i
              ].cuentaAgua;
              throw new Error(
                "La cuenta: " +
                  this.cuentaAgua +
                  " no tiene un proceso fiscal vigente."
              );
            }
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == 1 ||
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == 3
            ) {
              this.cancelaFiscalizacionesInput.idAgua.push(
                this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                  i
                ].idAgua
              );
              this.cancelaFiscalizacionesInput.idTipoDucumento = this.selecteddoc.id;
              this.cancelaFiscalizacionesInput.idUsuario = this.usuario.id;
            }
          } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
          }
        }
        console.log("Parametros CancelaFisc", this.cancelaFiscalizacionesInput);

        this.getCancelaFiscalizaciones(this.cancelaFiscalizacionesInput);
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados = null;
        console.log(
          "Limpia child",
          this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados
        );
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por Cancelar");
    }
  }
  onChange(event) {
    this.selecteddoc2 = null;
    this.selecteddoc2 = event.value;
    console.log(this.selecteddoc2);
  }
  async getCancelaFiscalizaciones(
    cancelaFiscalizacionesInput: CancelaFiscalizacionesInput
  ) {
    try {
      const datoRetorno = await this.cancelaFiscalizacionesService
        .getBusquedas(cancelaFiscalizacionesInput)
        .toPromise();
      this.cancelaFiscalizaciones = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.muestraMensaje.notification(
        "Proceso Concluido (Cancelar).",
        "top",
        "center"
      );
      console.log("Paso por  getCancelaFiscalizaciones");
    }
  }
  aplicar() {
    try {
      this.aplicaFiscalizacionesInput = new AplicaFiscalizacionesInput();
      if (
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados == null
      ) {
        throw new Error("Seleccionar una cuenta.");
      } else {
        for (
          var i = 0;
          i <
          this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados.length;
          i++
        ) {
          try {
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == null
            ) {
              this.cuentaAgua = null;
              this.cuentaAgua = this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                i
              ].cuentaAgua;
              throw new Error(
                "La cuenta: " + this.cuentaAgua + " no tiene un proceso fiscal."
              );
            }
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == 1
            ) {
              this.cuentaAgua = null;
              this.cuentaAgua = this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                i
              ].cuentaAgua;
              throw new Error(
                "La cuenta: " +
                  this.cuentaAgua +
                  " ya tiene el proceso fiscal vigente.."
              );
            }
            if (
              this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[i]
                .idEstatusFis == 3
            ) {
              this.aplicaFiscalizacionesInput.idAgua.push(
                this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados[
                  i
                ].idAgua
              );
              this.aplicaFiscalizacionesInput.idTipoDucumento = this.selecteddoc.id;
              this.aplicaFiscalizacionesInput.idUsuario = this.usuario.id;
            }
          } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
          }
        }
        console.log("Parametros AplicaFisc", this.aplicaFiscalizacionesInput);

        this.getAplicaFiscalizaciones(this.aplicaFiscalizacionesInput);
        this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados = null;
        console.log(
          "Limpia Child",
          this.childPadronAguaGenerales.PadronAguaGeneralesSeleccionados
        );
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por Generar");
    }
  }
  async getAplicaFiscalizaciones(
    aplicaFiscalizacionesInput: AplicaFiscalizacionesInput
  ) {
    try {
      const datoRetorno = await this.aplicaFiscalizacionesService
        .getBusquedas(aplicaFiscalizacionesInput)
        .toPromise();
      this.aplicaFiscalizaciones = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.muestraMensaje.notification(
        "Proceso Concluido (Aplicar).",
        "top",
        "center"
      );
      console.log("Paso por  getAplicaFiscalizaciones");
    }
  }
}
